import { Api } from "../config/request";

export default {
  getZomatoToBlinkitUploadUrl(payload) {
    return Api.post(
      `/driver-service-migration/zomato-to-blinkit/bulk-upload`,
      payload
    );
  },
  getBlinkitToZomatoUploadUrl(payload) {
    return Api.post(
      `/driver-service-migration/blinkit-to-zomato/bulk-upload`,
      payload
    );
  },
};
